<template>
	<label>
		<input
			:value="value"
     		@input="$emit('input', $event.target.value)"
			name="password"
			:type="showPassword ? 'text' : 'password'"
			required
			class="form-control"
			:placeholder='$t("components.checkout.login.password")'
		>

		<div class="show-password-label" @click="showPassword = !showPassword">
			{{ showPassword ? 'nascondi' : 'mostra' }}
		</div>
	</label>
</template>

<script>

export default {

	props: {
		value: {
			type: String,
			default: null
		}
	},

	data () {
		return {
			showPassword: false
		}
	}
}
</script>

<style scoped>
label {
	display: block;
	position: relative;
}
.show-password-label {
	cursor: pointer;
	font-weight: bold;
	position: absolute;
	top: 11px;
	right: 5px;
	padding: 0 5px;
	text-transform: uppercase;
	font-size: 12px;
}

</style>
